module.exports = __webpack_public_path__ + "img/spedy.8f8eaf0e.png";